export const environment = {
    envName: 'DEMO-DISTRIBUTION-AZURE',
    production: false,
    tenant: 'Go4Tms4Go4Apps.onmicrosoft.com',
    clientId: '5347f78f-a793-445c-b881-6667812032d3',

    authority: 'https://login.microsoftonline.com/Go4Tms4Go4Apps.onmicrosoft.com',
    redirectUrl: 'https://demo-distribution-test-pt4.go4tms.net/pt4',

    extApplicationEndpointAddress: 'https://demo-distribution-test-pt4.go4tms.net/pt4',
    tmsApiEndpointAddress: 'https://demo-distribution-test-pt4.go4tms.net/api/tms/v1/',
    hubEndpointAddress: 'https://demo-distribution-test-pt4.go4tms.net/client',
    tmsUserApiEndPointAddress: 'https://demo-distribution-test-pt4.go4tms.net/user/tms/v1/',
    ContainerPlanningApiUri : "https://demo-distribution-test.go4tms.net/cp/v1/", 
    
     defaultPlanningGroup : 'ALL',
    defaultPlanningZone : '',
    defaultPlanDaysAhead : 365,
    defaultPlanDaysBack : 365,
    disableToSelectionModal: false,
    depotInIcon : false , 
    depotOutIcon : false,
    iconType : "truck",
    maxDays : 3 ,
    collectionIcon: true,
    deliveryIcon: true,
    TODaysAhead : 365,
    TOdDaysBack : 365,
    shipping : false , 
    railway : false,
    tarTasEnabled: false,
    
    withQuotes: false,
    adminGroup : "PTADMINISTRATORS",
    containerReleaseEnabled: false,
    containerPoolEnabled: false,
    buisnessCentralUrl: 'https://demo-bc.go4tms.net/BC20DEMOTEST/', 
    showWaitingRoom : false ,
    
    
    MonitorAuthorizedUsers : "",
    checkOverlappingTos: false,
    app_base_href:'/pt4',   
  
    buisnessCentralCompany : 'GO4TMS DIS'    ,
    stackerIcon : false,
    instrumentationKey: ""
   
  };

